import React from "react";

import { SVGSprite } from "@/components/Atoms";

import { clsx } from "@/utils";
import Typography from "@/foundation/Typography/V2";

import styles from "./HeroSection.module.scss";

import data from "../data";

const HeroSection = () => {
  const { heading, title, description } = data?.hero;

  const content = (
    <div className={styles.content}>
      <Typography className={styles.description} variant="paragraph2">
        <span className={styles.title}>{title}</span>
        {description}
      </Typography>
    </div>
  );

  return (
    <div className={styles.heroSection}>
      <div className={clsx(styles.heroSectionContainer, "container")}>
        <div className={styles.contentWrapper}>
          <Typography variant="routelink1" to="/">
            <SVGSprite icon="icon-shyft-logo" className={styles.logo} />
          </Typography>
          <Typography className={styles.heading} variant="heading1">
            {heading}
          </Typography>
          {content}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
